import Alpine from '@alpinejs/csp';

export default (id) => ({
  serverTimestamp: null,
  init() {
    const self = this;
    this.$watch("$store.serverTimestamp", (value) => {
      self.serverTimestamp = value || null;
    });
  },
  get lot() {
    return Alpine.store(`lot${id}`);
  },
  get user() {
    return Number(Alpine.store("user").user_id);
  },
  // Attributes
  get startTimestamp() {
    return this.lot?.startTimestamp;
  },
  get endTimestamp() {
    return this.lot?.endTimestamp;
  },
  get highestBidder() {
    return this.lot?.highestBidder;
  },
  get userHasBids() {
    return this.lot?.userHasBids;
  },
  get currency() {
    return this.lot?.currency;
  },
  get userProxyBidAmount() {
    return this.lot?.userProxyBidAmount;
  },
  formatters: {
    EUR: new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }),
    GBP: new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }),
  },
  money(val, currency = "EUR") {
    const number = Number(val);
    if (Number.isNaN(number)) return "";
    const formatter = this.formatters[currency] ?? this.formatters.EUR;
    return formatter.format(number)
  },
  // State
  get isLoading() {
    return this.serverTimestamp === null;
  },
  get isOpening() {
    return (
      this.serverTimestamp !== null &&
      this.startTimestamp > this.serverTimestamp
    );
  },
  get isOpen() {
    return (
      this.serverTimestamp !== null &&
      this.startTimestamp <= this.serverTimestamp &&
      this.serverTimestamp <= this.endTimestamp
    );
  },
  get isExpiring () {
    if (this.serverTimestamp === null) {
      return false;
    } else {
      return (this.endTimestamp - this.serverTimestamp) < 300 * 1000;
    }
  },
  get isClosed() {
    return (
      this.serverTimestamp !== null &&
      this.serverTimestamp > this.endTimestamp
    );
  },
  // Timer
  get countdownTimer() {
    const diff = this.serverTimestamp !== null
      ? Math.max(0, this.endTimestamp - this.serverTimestamp)
      : 0;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = String(Math.floor(
      (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )).padStart(2, '0');
    const minutes = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
    const seconds = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2, "0");

    var formatted = `${hours}:${minutes}:${seconds}`;
    if (days > 0) {
      return `${days}d ${formatted}`;
    }
    return formatted;
  }
});
